import { LocaleCode, LocaleCodeEnum } from './types';

export const isLocaleCode = (locale: string): locale is LocaleCode =>
  Object.keys(LocaleCodeEnum).includes(locale);
